import { useTranslation } from 'react-i18next';
import { accountsFilterAtom } from 'src/atoms/filters/rsim-products';
import { DoughnutChartWidget } from 'src/common/components/Graphs/common/Graphs/components/DoughnutChartWidget';
import { RSimSubscriptionStatusChart } from './RSimSubscriptionStatusChart';
import { GraphAccountsValidator } from 'src/products/GraphAccountValidator';
import { useAccountRefs } from 'src/common/components/Accounts/useAccountRefs';
import { SubscriptionStateChartPlaceholder } from 'src/products/GraphValidatorPlaceholders';

export const RSimSubscriptionStateChartWidget = () => {
  const { t } = useTranslation();
  const accountRefs = useAccountRefs({ cslAccountAtom: accountsFilterAtom });

  const title = t('dashboard.subscriptionsStatusChart.title');

  return (
    <GraphAccountsValidator
      accountRefs={accountRefs}
      fallback={<SubscriptionStateChartPlaceholder title={title} />}
    >
      <DoughnutChartWidget title={title} accountRef={accountRefs[0]}>
        {(accountRef) => <RSimSubscriptionStatusChart accountRef={accountRef} />}
      </DoughnutChartWidget>
    </GraphAccountsValidator>
  );
};
